import React from 'react'

/**
 * Page Properties Dialog Component
 * Handles editing page properties including dimensions, units, and background color
 */
const PagePropertiesDialog = ({
  showPagePropertiesDialog,
  setShowPagePropertiesDialog,
  pageProperties,
  setPageProperties,
  savePageProperties,
  fromPx,
  toPx
}) => {
  if (!showPagePropertiesDialog) {
    return null
  }

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[550] p-4">
      <div className="bg-white rounded-lg w-96 max-w-[90vw] max-h-[90vh] flex flex-col">
        <div className="flex-shrink-0 p-6 pb-4">
          <h3 className="text-lg font-semibold">Page Properties</h3>
        </div>
        <div className="flex-1 overflow-y-auto px-6 space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Unit</label>
            <select
              value={pageProperties.unit}
              onChange={(e) => setPageProperties(prev => ({ ...prev, unit: e.target.value }))}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="px">Pixels</option>
              <option value="mm">Millimeters</option>
              <option value="cm">Centimeters</option>
              <option value="in">Inches</option>
              <option value="ft">Feet</option>
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Width ({pageProperties.unit})</label>
            <input
              type="number"
              value={fromPx(pageProperties.width, pageProperties.unit)}
              onChange={(e) => setPageProperties(prev => ({ ...prev, width: toPx(parseFloat(e.target.value), prev.unit) }))}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              min="1"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Height ({pageProperties.unit})</label>
            <input
              type="number"
              value={fromPx(pageProperties.height, pageProperties.unit)}
              onChange={(e) => setPageProperties(prev => ({ ...prev, height: toPx(parseFloat(e.target.value), prev.unit) }))}
              className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
              min="1"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Background Color</label>
            <input
              type="color"
              value={pageProperties.backgroundColor}
              onChange={(e) => setPageProperties(prev => ({ ...prev, backgroundColor: e.target.value }))}
              className="w-full h-10 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
        <div className="flex-shrink-0 flex justify-end space-x-2 p-6 pt-4 border-t border-gray-200">
          <button
            onClick={() => setShowPagePropertiesDialog(false)}
            className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
          >
            Cancel
          </button>
          <button
            onClick={savePageProperties}
            className="px-4 py-2 bg-blue-500 text-white hover:bg-blue-600 rounded"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  )
}

export default PagePropertiesDialog
